import React = require("react");
import ModuleData from "./ModuleData";

import { WebViewProps } from "../interfaces";

export interface SpacerWebViewProps extends WebViewProps<ModuleData>, React.Props<SpacerWebView> {
}

export default class SpacerWebView extends React.Component<SpacerWebViewProps, {}> {
    render() {
        return (
            <div
                className={`the-spacer id${this.props.moduleId}`}
                style={{height: this.props.payload.heightInPixels}}
            />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/spacer/WebView.tsx
 **/